import React from 'react';
import { ShieldCheckIcon, HeartIcon, BanIcon, CheckIcon, UsersIcon, BookOpenIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { TopBar } from '../components/TopBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function AboutUsPage() {
  return <div className="flex flex-col min-h-screen w-full" data-id="element-412" data-mp="29vked3g3c6ov">
      <TopBar data-id="element-413" data-mp="36kryc712a7qo" />
      <Header data-id="element-414" data-mp="36j74kjmkmstv" />

      {/* Hero Section */}
      <section className="w-full bg-white py-20 md:py-28 border-b border-gray-200" data-id="element-415" data-mp="36mcshvjgroo0">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-416" data-mp="32jgigt7zp0vo">
          <div className="max-w-4xl mx-auto text-center" data-id="element-417" data-mp="2xr58syng60px">
            <h1 className="mb-6 text-5xl md:text-6xl font-extrabold text-[#111111] leading-tight" data-id="element-418" data-mp="2xplq71ebjdkz">
              Most tech advice is secretly an ad. Ours isn't.
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 leading-relaxed" data-id="element-419" data-mp="3q9k9m13zr85s">
              We're Caveo — your family's Digital Fiduciary. That means we're
              legally and ethically bound to act in your interest. Not the
              interests of advertisers, affiliates, or anyone else. Your trust
              is our product. Not your data. Not your clicks.
            </p>
          </div>
        </div>
      </section>

      {/* What is a Digital Fiduciary */}
      <section className="w-full bg-[#f8f8f8] py-16 md:py-24" data-id="element-420" data-mp="7lgui75isz02">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-421" data-mp="3pseotidsjpad">
          <div className="max-w-4xl mx-auto" data-id="element-422" data-mp="3pqtsbn7x1w9v">
            <div className="flex items-center justify-center mb-8" data-id="element-423" data-mp="3urr9pxl3qmab">
              <div className="w-16 h-16 bg-[#631bb7] bg-opacity-10 rounded-2xl flex items-center justify-center" data-id="element-424" data-mp="3uovbe85cdvlc">
                <ShieldCheckIcon className="w-8 h-8 text-[#631bb7]" data-id="element-425" data-mp="3kt24p5eb0wbh" />
              </div>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-6 text-center" data-id="element-426" data-mp="1f0d69zqcdj1y">
              What is a Digital Fiduciary?
            </h2>
            <div className="bg-white rounded-2xl p-8 border-2 border-gray-200 mb-8" data-id="element-427" data-mp="1j15i90qlm21x">
              <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-428" data-mp="2rzf28dwwu3gl">
                A <strong className="text-[#111111]" data-id="element-429" data-mp="2mz9h7gl5bf7h">fiduciary</strong> is
                someone who is legally obligated to act in your best interest.
                Financial advisors, doctors, and lawyers are fiduciaries. They
                can't recommend something just because they get paid more for
                it.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-430" data-mp="3aobtsa0xahv4">
                A <strong className="text-[#111111]" data-id="element-431" data-mp="36otbzn4eemwi">Digital Fiduciary</strong>{' '}
                applies this same standard to technology advice. When we
                recommend a password manager, a privacy setting, or a security
                tool—it's because it's genuinely the best choice for you, not
                because we get a kickback.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Affiliate Bias Ruins Recommendations */}
      <section className="w-full bg-white py-16 md:py-24 border-t border-gray-200" data-id="element-432" data-mp="t6b4d81mqbu">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-433" data-mp="5qpqjggh995d">
          <div className="max-w-4xl mx-auto" data-id="element-434" data-mp="5tbxbdvjnkmj">
            <div className="flex items-center justify-center mb-8" data-id="element-435" data-mp="aq2j8hu15afv">
              <div className="w-16 h-16 bg-red-50 rounded-2xl flex items-center justify-center" data-id="element-436" data-mp="erxm3qrlzvvr">
                <BanIcon className="w-8 h-8 text-red-500" data-id="element-437" data-mp="jr0eaamhq7mb" />
              </div>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-6 text-center" data-id="element-438" data-mp="oq3mu51oivz1">
              Here's the conflict of interest most tech advice sites don't tell
              you about.
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-8 text-center" data-id="element-439" data-mp="yfn5b9lhcntd">
              Most "tech help" sites make money through affiliate links. That
              creates a fundamental conflict of interest.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-440" data-mp="17hcxwir3lssq">
              <div className="bg-red-50 rounded-2xl p-6 border-2 border-red-100" data-id="element-441" data-mp="ttcln0uewld6">
                <h3 className="text-xl font-bold text-[#111111] mb-4" data-id="element-442" data-mp="psittwdummf0">
                  How most "free" tech advice works
                </h3>
                <ul className="space-y-3" data-id="element-443" data-mp="13icmkpsh5qu0">
                  <li className="flex items-start" data-id="element-444" data-mp="ykksbp4cxsmn">
                    <span className="text-red-500 mr-2" data-id="element-445" data-mp="ylvuxlm2guc6">✗</span>
                    <span className="text-gray-600" data-id="element-446" data-mp="augophr65svn">
                      They recommend products that pay the highest commission
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-447" data-mp="kt685eyprle0">
                    <span className="text-red-500 mr-2" data-id="element-448" data-mp="ktz73trfl6ll">✗</span>
                    <span className="text-gray-600" data-id="element-449" data-mp="ftjwvb2g4f7u">
                      They push unnecessary software to increase sales
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-450" data-mp="1wa60uboz428k">
                    <span className="text-red-500 mr-2" data-id="element-451" data-mp="1r8gmon6gf8g9">✗</span>
                    <span className="text-gray-600" data-id="element-452" data-mp="3974t531guv00">
                      They create fear to drive purchases
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-453" data-mp="3e79eb6dbkdwk">
                    <span className="text-red-500 mr-2" data-id="element-454" data-mp="306ylhxsg8p8r">✗</span>
                    <span className="text-gray-600" data-id="element-455" data-mp="308jhlruewg8q">
                      Their "reviews" are really advertisements
                    </span>
                  </li>
                </ul>
              </div>

              <div className="bg-[#631bb7] bg-opacity-5 rounded-2xl p-6 border-2 border-[#631bb7] border-opacity-20" data-id="element-456" data-mp="r1ybxvgd0t3">
                <h3 className="text-xl font-bold text-[#111111] mb-4" data-id="element-457" data-mp="3j5kmlcnyugco">
                  How Caveo is different
                </h3>
                <ul className="space-y-3" data-id="element-458" data-mp="3o2uj1c9rvsa0">
                  <li className="flex items-start" data-id="element-459" data-mp="foc892sg5ymp">
                    <CheckIcon className="w-5 h-5 text-[#631bb7] mr-2 flex-shrink-0" data-id="element-460" data-mp="fnkc9quxtyvw" />
                    <span className="text-gray-600" data-id="element-461" data-mp="kg3zlfjfg8dw">
                      We tell you what to actually do — not what to buy
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-462" data-mp="pc7th9zl8grv">
                    <CheckIcon className="w-5 h-5 text-[#631bb7] mr-2 flex-shrink-0" data-id="element-463" data-mp="pcpusl13xl6n" />
                    <span className="text-gray-600" data-id="element-464" data-mp="kba9qsyxjeo9">
                      We'll recommend free tools when they're the right answer
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-465" data-mp="bd8deqq55a7b">
                    <CheckIcon className="w-5 h-5 text-[#631bb7] mr-2 flex-shrink-0" data-id="element-466" data-mp="be00te9l41mi" />
                    <span className="text-gray-600" data-id="element-467" data-mp="6jdmp3c4buyq">
                      We guide you through action, not anxiety
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-468" data-mp="3stzoyycxniut">
                    <CheckIcon className="w-5 h-5 text-[#631bb7] mr-2 flex-shrink-0" data-id="element-469" data-mp="3ntkc07wkcddd" />
                    <span className="text-gray-600" data-id="element-470" data-mp="3nveocxtrqx5u">
                      Our only incentive is your safety — we're paid by you, not
                      by anyone else
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="bg-[#1a0647] rounded-2xl p-8 text-center" data-id="element-471" data-mp="239q1ntnvirv4">
              <p className="text-xl text-white font-semibold mb-2" data-id="element-472" data-mp="28bnsb8ylsoy3">
                "If you're not paying for the product, you are the product."
              </p>
              <p className="text-white text-opacity-70" data-id="element-473" data-mp="1flysv01jkwyl">
                With Caveo, you're paying for honest guidance. That's it.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Mission */}
      <section className="w-full bg-[#f8f8f8] py-16 md:py-24 border-t border-gray-200" data-id="element-474" data-mp="1pj3dgvfqokda">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-475" data-mp="1ub4lg55vjoxi">
          <div className="max-w-4xl mx-auto text-center" data-id="element-476" data-mp="1uco5m6unik4k">
            <div className="flex items-center justify-center mb-8" data-id="element-477" data-mp="wuo3inbgss8t">
              <div className="w-16 h-16 bg-[#631bb7] bg-opacity-10 rounded-2xl flex items-center justify-center" data-id="element-478" data-mp="11u0m2vvazd5l">
                <HeartIcon className="w-8 h-8 text-[#631bb7]" data-id="element-479" data-mp="3rdnefmn9me67" />
              </div>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-6" data-id="element-480" data-mp="3mekkoycqjudj">
              What we believe
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed mb-8" data-id="element-481" data-mp="49h7srgj2e2k">
              We believe everyone deserves to feel confident and safe
              online—regardless of age, background, or technical skill.
              Technology should bring families together, not create stress and
              dependency.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-482" data-mp="mye4t33b7koh">
              <div className="bg-white rounded-xl p-6 border-2 border-gray-200" data-id="element-483" data-mp="mxm81oxz7gwm">
                <UsersIcon className="w-8 h-8 text-[#631bb7] mx-auto mb-4" data-id="element-484" data-mp="iy3nwvdzb9uu" />
                <h3 className="font-bold text-[#111111] mb-2" data-id="element-485" data-mp="wvscad798z4n">Family-First</h3>
                <p className="text-gray-600 text-sm" data-id="element-486" data-mp="rxqt7s9twzt6">
                  Every guide, every check-in, every feature is built with the
                  whole household in mind — from the most technical person to
                  the least.
                </p>
              </div>
              <div className="bg-white rounded-xl p-6 border-2 border-gray-200" data-id="element-487" data-mp="1gg0w9wosslbf">
                <BookOpenIcon className="w-8 h-8 text-[#631bb7] mx-auto mb-4" data-id="element-488" data-mp="11kun50ueo6dv" />
                <h3 className="font-bold text-[#111111] mb-2" data-id="element-489" data-mp="16iwc22eiizx9">
                  Action Over Anxiety
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-490" data-mp="sqprm44bu6s0">
                  We don't teach you to be scared — we walk you through what to
                  do. There's a difference.
                </p>
              </div>
              <div className="bg-white rounded-xl p-6 border-2 border-gray-200" data-id="element-491" data-mp="ntplxube361f">
                <ShieldCheckIcon className="w-8 h-8 text-[#631bb7] mx-auto mb-4" data-id="element-492" data-mp="nrlkrk4vkl4u" />
                <h3 className="font-bold text-[#111111] mb-2" data-id="element-493" data-mp="9ughtt0gk2dt">
                  Radical Honesty
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-494" data-mp="dxmj0m8pr3df">
                  No kickbacks. No hidden agendas. No upsells. If you don't need
                  it, we won't recommend it — and we'll tell you that directly.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="w-full bg-white py-16 md:py-24 border-t border-gray-200" data-id="element-495" data-mp="3uf6psqbdpd5l">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-496" data-mp="lzwpnnr1ui0g">
          <div className="max-w-3xl mx-auto text-center" data-id="element-497" data-mp="m0gabc833ki6">
            <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-4" data-id="element-498" data-mp="qzj4g1mj06bd">
              See the difference honest guidance makes.
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-8" data-id="element-499" data-mp="d5if1yhgrvno">
              Start with a free checkup — no email required, no strings
              attached. Just a clear picture of what your family needs to do.
            </p>
            <Link to="/onboarding" className="bg-[#631bb7] text-white px-8 py-4 rounded-lg font-bold inline-flex items-center justify-center no-underline hover:bg-[#521099] transition-all shadow-md" data-id="element-500" data-mp="19p91kvdrh46g">
              Get Started
            </Link>
          </div>
        </div>
      </section>

      <Footer data-id="element-501" data-mp="344o8gs8r2xr2" />
    </div>;
}